import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Mail, Youtube } from "lucide-react";
import Logo from "./Logo";

const SIGNIN_URL = process.env.REACT_APP_SIGNIN_URL;

const COLUMNS = [
  { title: "Platform", links: [["Portals", "/#portals"], ["Features", "/#features"], ["Patient journey", "/#journey"], ["Security", "/#security"]] },
  { title: "Solutions", links: [["For clinics", "/#contact"], ["For hospitals", "/#contact"], ["For health networks", "/#contact"], ["Book a demo", "/#contact"]] },
  { title: "Account", links: [["Sign in", SIGNIN_URL, true], ["Patients: book a visit", SIGNIN_URL, true], ["FAQ", "/#faq"]] },
  { title: "Legal", links: [["Terms of service", "/terms"], ["Privacy policy", "/privacy"], ["Refund policy", "/refund-policy"]] },
];

const Footer = () => (
  <footer className="border-t border-slate-200 bg-white">
    <div className="container-x grid gap-10 py-14 lg:grid-cols-[minmax(0,1.3fr)_repeat(4,minmax(0,1fr))]">
      <div>
        <Logo />
        <p className="mt-4 max-w-xs text-sm text-slate-600">The connected operating system for clinics and hospitals — from appointments to discharge.</p>
        <div className="mt-5 flex gap-2">
          {[[Mail, "mailto:techfrigate@gmail.com", "Email"], [Linkedin, "#", "LinkedIn"], [Youtube, "#", "YouTube"]].map(([Icon, href, label]) => (
            <a key={label} href={href} aria-label={label} className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 text-slate-500 hover:border-brand-300 hover:text-brand-600">
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
      {COLUMNS.map((c) => (
        <div key={c.title}>
          <p className="text-sm font-semibold text-ink-900">{c.title}</p>
          <ul className="mt-4 space-y-2.5">
            {c.links.map(([label, href, external]) => (
              <li key={label}>
                {external || href.startsWith("/#") ? (
                  <a href={href} className="text-sm text-slate-600 hover:text-brand-700">{label}</a>
                ) : (
                  <Link to={href} className="text-sm text-slate-600 hover:text-brand-700">{label}</Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-slate-200">
      <div className="container-x flex flex-col items-center justify-between gap-2 py-6 text-xs text-slate-500 sm:flex-row">
        <p>© {new Date().getFullYear()} Health Frigate®. All rights reserved.</p>
        <p>Made for healthcare teams in India.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
